import instance from "@u/request";
import { getRefreshToken } from "@u/cookies";

export function Register(data = {}) {
    return instance.request({
        method: "post",
        url: "/sys/register",
        data
    })
}

export function Login(data = {}) {
    return instance.request({
        method: "post",
        url: "/login",
        data
    })
}

export function Logout() {
    instance.interceptors.request.use(function (config) {
        if (getRefreshToken()) {
            config.headers['referehToken'] = getRefreshToken();         //携带token
        }
        return config;
    }, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    });
    return instance.request({
        method: "post",
        url: "/logout"
    })
}

export function ResetPassword(data = '') {
    return instance.request({
        method: "get",
        url: "/sys/send/password/" + data
    })
}

export function ChangePassword(data = {}) {
    return instance.request({
        method: "post",
        url: "/changePassword",
        data
    })
}

export function GetInformation() {
    return instance.request({
        method: "get",
        url: "/sys/information"
    })
}

export function GetCountryList() {
    return instance.request({
        method: "get",
        url: "/country/list"
    })
}

export function UpdateUnit() { //切换血糖单位
    return instance.request({
        method: "get",
        url: "/sys/update/measureunit"
    })
}

export function UpdateUaUnit() { //切换尿酸单位
    return instance.request({
        method: "get",
        url: "/sys/update/uaMeasureUnit"
    })
}




// WEBPACK FOOTER //
// ./src/api/account.js